import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useOpportunitiesStore } from "../store/opportunities.store";
import { useOpportunity } from "../hook/partner/opportunity.partner.hook";
import { NavLink, useParams } from "react-router";
import { PartnerApi } from "../api/partner.api";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import number_format from "../utils/number_format";
import CommentNewModal from "../components/modals/comment/CommentNewModal";
import InvoiceDetailModal from "../components/modals/invoice/InvoiceDetailModal";
import Comments from "../components/Comments/Comments";
import ShippingTableOpp from "../components/Shipping/ShippingTableOpp";
import ProductsCatalog from "../components/Products/ProductsCatalog";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement } from "chart.js";
import { Accordion, Modal } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import SoldSNSearch from "../components/modals/soldsn/SoldSNSearch";
import DeliveryAddressNewModal from "../components/modals/deal/DeliveryAddressNewModal";
import OpportunityExportModal from "../components/modals/opportunity/OpportunityExportModal";
import OpportunityExportSNModal from "../components/modals/opportunity/OpportunityExportSNModal";
import ShippingPackagesTableOpp from "../components/Shipping/ShippingPackagesTableOpp";
import ClaimNewModal from "../components/modals/claim/ClaimNewModal";
import { useTranslation } from "../hooks/useTranslation";

function Opportunity() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [shipping, setShipping] = useState(null);
  const [reload, setReload] = useState(0);
  const opportunityMutation = useOpportunity();

  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.getCurrentUser());
  const isInternalAdmin = useAuthStore((state) => state.isInternalAdmin());
  const opportunity = useOpportunitiesStore((state) => state.opportunity);
  const [activeVariation, setActiveVariation] = useState(0);

  const [errorAdd, setErrorAdd] = useState(null);
  const [descriptionNew, setDescriptionNew] = useState("");

  const [showInvoiceModal, setShowInvoiceModal] = useState(false);

  const [products, setProducts] = useState(null);
  const [selectedProductAdd, setSelectedProductAdd] = useState(null);
  const [errorAddProduct, setErrorAddProduct] = useState(null);
  const [errorEditProduct, setErrorEditProduct] = useState(null);
  const [searchProduct, setSearchProduct] = useState("");

  const [invoiceToShow, setInvoiceToShow] = useState(null);
  const [showSN, setShowSN] = useState(null);

  const [showExportModal, setShowExportModal] = useState(false);
  const [showExportSNModal, setShowExportSNModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showNewAddressModal, setShowNewAddressModal] = useState(false);
  const [showClaimModal, setShowClaimModal] = useState(false);

  Chart.register(ArcElement);

  useEffect(() => {
    if (opportunity) {
      PartnerApi.opportunityShipping({ token, id }).then((result) => {
        if (!("error" in result)) {
          setShipping(result);
        }
      });
    }
  }, [id, opportunity]);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(opportunity ? t("opportunities.opportunityTitle", { id, description: opportunity.description }) : "");
    setBreadcrumbs([
      {
        name: t("opportunities.title"),
        link: "/prilezitosti",
      },
    ]);
  }, [opportunity, id]);

  useEffect(() => {
    if (selectedProductAdd) {
      addProduct(selectedProductAdd);
    }
  }, [token, selectedProductAdd]);

  const createNewVariant = (event) => {
    event.preventDefault();
    setErrorAdd(null);
    const result = PartnerApi.opportunityVariantAdd({
      token,
      opportunity_id: id,
      description: descriptionNew,
    });
    result.then((result) => {
      if ("error" in result) {
        setErrorAdd(result.error);
        return;
      }
      window.document.getElementById("variant-add-close").click();
      setReload(reload + 1);
      setActiveVariation(opportunity.opportunity_variations?.length);
    });
    return false;
  };

  const addProduct = (selectedProductId) => {
    setErrorAddProduct(null);
    setSelectedProductAdd(null);
    setProducts(null);
    let variation_id = 0;
    opportunity.opportunity_variations.map((variation, variation_key) => {
      if (activeVariation == variation_key) {
        variation_id = variation.variation_id;
      }
    });
    const result = PartnerApi.opportunityVariantProductAdd({
      token,
      opportunity_id: id,
      variation_id: variation_id,
      product_id: selectedProductId,
      quantity: 1,
    });
    result.then((result) => {
      if ("error" in result) {
        setErrorAddProduct(result.error);
        return;
      }
      window.document.getElementById("product-add-close").click();
      setReload(reload + 1);
    });
    return false;
  };

  const changeProduct = (item_id, quantity) => {
    setErrorEditProduct(null);
    let variation_id = 0;
    opportunity.opportunity_variations.map((variation, variation_key) => {
      if (activeVariation == variation_key) {
        variation_id = variation.variation_id;
      }
    });
    const result = PartnerApi.opportunityVariantProductChange({
      token,
      opportunity_id: id,
      variation_id: variation_id,
      item_id: item_id,
      quantity: quantity,
    });
    result.then((result) => {
      if ("error" in result) {
        setErrorEditProduct(result.error);
        return;
      }
      setReload(reload + 1);
    });
    return false;
  };

  const deleteProduct = (item_id) => {
    let variation_id = 0;
    opportunity.opportunity_variations.map((variation, variation_key) => {
      if (activeVariation == variation_key) {
        variation_id = variation.variation_id;
      }
    });
    const result = PartnerApi.opportunityVariantProductDelete({
      token,
      opportunity_id: id,
      variation_id: variation_id,
      item_id: item_id,
    });
    result.then((result) => {
      if ("error" in result) {
        return;
      }
      setReload(reload + 1);
    });
    return false;
  };

  const orderOpportunity = () => {
    if (!window.confirm(t("opportunities.confirmSendOrder"))) {
      return false;
    }
    const result = PartnerApi.opportunityPlaceOrder({
      token,
      id,
    }).then((result) => {
      setShowOrderModal(false);
      opportunityMutation.mutate({ token, id });
    });

    return false;
  };

  const cancelOpportunity = () => {
    if (!window.confirm(t("opportunities.confirmCancelDeal"))) {
      return false;
    }

    const result = PartnerApi.opportunityCancelOpportunity({
      token,
      id,
    }).then((result) => {
      opportunityMutation.mutate({ token, id });
    });

    return false;
  };

  const editOppotunityShort = (data) => {
    const result = PartnerApi.opportunityEdit({
      token,
      id,
      data,
    }).then((result) => {
      opportunityMutation.mutate({ token, id });
    });
  };

  const editOppotunity = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = {};
    formData.forEach(function (value, key) {
      data[key] = value;
    });

    const result = PartnerApi.opportunityEdit({
      token,
      id,
      data,
    }).then((result) => {
      const elements = document.getElementsByClassName("js-close-modal");
      Array.from(elements).forEach((el) => {
        if (!!el.offsetParent) el.click();
      });
      opportunityMutation.mutate({ token, id });
    });

    return false;
  };

  const setDefaultVariation = (defaultVariation) => {
    const data = { defaultVariation };
    const result = PartnerApi.opportunityEdit({
      token,
      id,
      data,
    }).then((result) => {
      opportunityMutation.mutate({ token, id });
      setActiveVariation(0);
    });
  };

  useEffect(() => {
    if (token) {
      opportunityMutation.mutate({ token, id });
    }
  }, [token, id, reload]);

  function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return "" + Math.round(n * k) / k;
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }

  useEffect(() => {
    if (!token || !searchProduct) return;

    const controller = new AbortController();
    const timeout = setTimeout(() => {
      setErrorAddProduct(null);
      PartnerApi.productSearch({ token, search: searchProduct, signal: controller.signal }).then(
        (result) => {
          if (controller.signal.aborted) return;
          if ("error" in result) {
            setErrorAddProduct(result.error);
            setProducts([]);
            return;
          }
          setProducts(result);
        }
      ).catch(() => {});
    }, 300);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [token, searchProduct]);

  if (!opportunity) {
    return <>{t("common.loading")}</>;
  }

  if (opportunity && !opportunity.description) {
    return (
      <>
        <span className="alert alert-danger">{t("common.notFound")}</span>
      </>
    );
  }

  const isWritable = () => {
    if (
      opportunity.access_rights_of_current_user == "writeAndOrder" ||
      opportunity.access_rights_of_current_user == "write"
    ) {
      return true;
    }

    return false;
  };

  return (
    <>
      <Modal show={showOrderModal} onHide={() => setShowOrderModal(false)}>
        <Modal.Header closeButton>{t("opportunities.sendingOrder")}</Modal.Header>
        <Modal.Body>
          <p>
            {t("opportunities.beforeSendingOrderMessage")}
          </p>
          <div className="row">
            <div className="col-6">
              <small>{t("opportunities.currency")}</small>
              <select
                className="form-control form-control-solid"
                defaultValue={opportunity.purchase_currency}
                onChange={(e) =>
                  editOppotunityShort({ purchase_currency: e.target.value })
                }
              >
                <option value="CZK">CZK</option>
                <option value="EUR">EUR</option>
                <option value="USD">USD</option>
              </select>
            </div>
            <div className="col-6">
              <small>{t("opportunities.yourOrderNumber")}</small>
              <input
                type="text"
                className="form-control form-control-solid"
                defaultValue={opportunity.partner_order_id}
                onBlur={(e) =>
                  editOppotunityShort({ partner_order_id: e.target.value })
                }
              />
            </div>
            <div className="col-12 mt-3">
              <small>{t("opportunities.endCustomerContact")}</small>
              <input
                className="form-control form-control-solid"
                defaultValue={
                  (opportunity?.end_customer?.person?.first_name
                    ? opportunity.end_customer.person.first_name
                    : "") +
                  " " +
                  (opportunity?.end_customer?.person?.last_name
                    ? opportunity.end_customer.person.last_name
                    : "")
                }
                onBlur={(e) =>
                  editOppotunityShort({ contact_person: e.target.value })
                }
              />
            </div>
            <div className="col-12 mt-3">
              <small>{t("opportunities.deliveryAddressHw")}</small>
            </div>
          </div>
          <div className="row">
            <div className="col-8">
              <select
                className="form-control form-control-solid"
                defaultValue={opportunity?.delivery_address_id}
                onChange={(e) =>
                  editOppotunityShort({ delivery_address_id: e.target.value })
                }
              >
                <option value="0">{t("opportunities.selectAddress")}</option>
                {opportunity?.delivery_addresses?.map((address) => (
                  <option key={address.address_id} value={address.address_id}>
                    {address.name}, {address.street}, {address.city}
                  </option>
                ))}
              </select>
            </div>
            <div
              className="col-4 text-end"
              onClick={() => setShowNewAddressModal(true)}
            >
              <button className="btn btn-primary">{t("common.add")}</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowOrderModal(false)}
          >
            {t("common.close")}
          </button>
          <button
            className="btn btn-primary"
            onClick={() => orderOpportunity()}
          >
            {t("opportunities.order")}
          </button>
        </Modal.Footer>
      </Modal>
      <DeliveryAddressNewModal
        show={showNewAddressModal}
        handleClose={() => setShowNewAddressModal(false)}
        callback={() => setReload(reload + 1)}
        company_id={opportunity.end_customer.company_id}
        id={"delivery-address-new"}
      />
      {showSN && (
        <SoldSNSearch
          showSNDirectly={showSN}
          hideExternal={() => setShowSN(false)}
        />
      )}
      <form
        onSubmit={(e) => createNewVariant(e)}
        className="modal fade"
        tabIndex="-1"
        id={"variant-new"}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{t("opportunities.newVariant")}</h3>
            </div>

            <div className="modal-body">
              {errorAdd && <p className="alert alert-danger">{errorAdd}</p>}
              <div className="mb-10">
                <label
                  htmlFor="formObchodniNazev"
                  className="required form-label"
                >
                  {t("opportunities.variantName")}
                </label>
                <input
                  type="text"
                  id="formObchodniNazev"
                  defaultValue={descriptionNew}
                  key={"descriptionNew" + opportunity?.opportunity_id}
                  required={true}
                  onChange={(e) => setDescriptionNew(e.target.value)}
                  className="form-control form-control-solid"
                  placeholder={t("opportunities.enterName")}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="variant-add-close"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                {t("common.close")}
              </button>
              <button type="submit" className="btn btn-primary">
                {t("common.create")}
              </button>
            </div>
          </div>
        </div>
      </form>
      <div className="modal fade" tabIndex="-1" id={"product-add"}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{t("opportunities.addProduct")}</h3>
            </div>

            <div className="modal-body">
              {errorAddProduct && (
                <p className="alert alert-danger">{errorAddProduct}</p>
              )}
              <div className="mb-10">
                <div className="d-flex align-items-center position-relative my-1">
                  <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                  <input
                    type="text"
                    className="form-control form-control-solid ps-12"
                    placeholder={t("common.search")}
                    onChange={(e) => setSearchProduct(e.target.value)}
                  />
                </div>

                <div style={{ maxHeight: "60vh", overflow: "auto" }}>
                  <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                    {products?.map((product, product_key) => (
                      <div className="menu-item" key={product_key}>
                        <a
                          href="#"
                          onClick={() =>
                            setSelectedProductAdd(product.product_id)
                          }
                          className={
                            "menu-link " +
                            (selectedProductAdd == product.product_id
                              ? "active"
                              : "")
                          }
                        >
                          {selectedProductAdd == product.product_id && (
                            <span className="menu-icon" data-kt-element="icon">
                              <i className="ki-duotone ki-check fs-2">
                                <span className="path1"></span>
                                <span className="path2"></span>
                              </i>
                            </span>
                          )}

                          <span className="menu-title">
                            {product.name}
                            <br />
                            SKU: {product.sku}
                          </span>
                        </a>
                      </div>
                    ))}
                    <ProductsCatalog
                      vendor_id={
                        opportunity &&
                        opportunity.opportunity_variations &&
                        opportunity?.opportunity_variations[0]?.items[0]
                          ?.product.vendor_id
                      }
                      addProduct={addProduct}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="product-add-close"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                Zavřit
              </button>
            </div>
          </div>
        </div>
      </div>
      <form
        onSubmit={(e) => editOppotunity(e)}
        className="modal fade"
        tabIndex="-1"
        id="opportunity_edit_description"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{t("opportunities.opportunityChange")}</h3>
            </div>
            <div className="modal-body">
              <div className="mb-10">
                <label
                  htmlFor="formObchodniNazev"
                  className="required form-label"
                >
                  {t("opportunities.dealName")}
                </label>
                <input
                  type="text"
                  id="formObchodniNazev"
                  defaultValue={opportunity.description}
                  key={"descriptionNew2" + opportunity?.opportunity_id}
                  required={true}
                  name="description"
                  className="form-control form-control-solid"
                  placeholder={t("opportunities.enterName")}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light js-close-modal"
                data-bs-dismiss="modal"
              >
                Zavřit
              </button>
              <button type="submit" className="btn btn-primary">
                {t("common.save")}
              </button>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => editOppotunity(e)}
        className="modal fade"
        tabIndex="-1"
        id="opportunity_edit_invoice_date"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{t("opportunities.opportunityChange")}</h3>
            </div>
            <div className="modal-body">
              <div className="mb-10">
                <label
                  htmlFor="forminvoice_currency"
                  className="required form-label"
                >
                  {t("opportunities.dateInvoiced")}
                </label>
                <input
                  type="date"
                  id="forminvoice_date"
                  defaultValue={opportunity.invoice_date}
                  key={"invoice_date" + opportunity?.opportunity_id}
                  required={true}
                  name="invoice_date"
                  className="form-control form-control-solid"
                  placeholder={t("opportunities.enterName")}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light js-close-modal"
                data-bs-dismiss="modal"
              >
                Zavřit
              </button>
              <button type="submit" className="btn btn-primary">
                {t("common.save")}
              </button>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => editOppotunity(e)}
        className="modal fade"
        tabIndex="-1"
        id="opportunity_edit_invoice_currency"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{t("opportunities.opportunityChange")}</h3>
            </div>
            <div className="modal-body">
              <div className="mb-10">
                <label
                  htmlFor="formMenaFaktura"
                  className="required form-label"
                >
                  {t("opportunities.currency")}
                </label>
                <select
                  id="formMenaFaktura"
                  defaultValue={opportunity.purchase_currency}
                  key={"currency" + opportunity?.opportunity_id}
                  required={true}
                  name="purchase_currency"
                  className="form-control form-control-solid"
                >
                  <option value="CZK">CZK</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light js-close-modal"
                data-bs-dismiss="modal"
              >
                Zavřit
              </button>
              <button type="submit" className="btn btn-primary">
                {t("common.save")}
              </button>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => editOppotunity(e)}
        className="modal fade"
        tabIndex="-1"
        id="opportunity_edit_invoice_currency"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{t("opportunities.opportunityChange")}</h3>
            </div>
            <div className="modal-body">
              <div className="mb-10">
                <label
                  htmlFor="formEndCustomer"
                  className="required form-label"
                >
                  {t("opportunities.endCustomer")}
                </label>
                <select
                  id="formEndCustomer"
                  defaultValue={opportunity.purchase_currency}
                  required={true}
                  name="invoice_currency"
                  className="form-control form-control-solid"
                >
                  <option value="CZK">CZK</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light js-close-modal"
                data-bs-dismiss="modal"
              >
                Zavřit
              </button>
              <button type="submit" className="btn btn-primary">
                {t("common.save")}
              </button>
            </div>
          </div>
        </div>
      </form>
      <InvoiceDetailModal
        invoice_id={invoiceToShow}
        show={showInvoiceModal}
        handleClose={() => setShowInvoiceModal(false)}
        token={token}
      />
      <div className="d-flex justify-content-between py-4">
        <h1>
          {t("opportunities.opportunityTitle", { id, description: opportunity.description })}
          &nbsp;
          {isWritable() && (
            <i
              className="ki-duotone ki-pencil fs-2 cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#opportunity_edit_description"
            >
              <span className="path1"></span>
              <span className="path2"></span>
            </i>
          )}
        </h1>
        <div className="text-end">
          {opportunity?.invoices?.map((i) => (
            <button
              className="btn btn-info ms-2 mb-2"
              onClick={() => {
                setShowInvoiceModal(true);
                setInvoiceToShow(i.invoice_id);
              }}
            >
              <i className="ki-duotone ki-document fs-4 cursor-pointer">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>{" "}
              {t("opportunities.invoice")} {i.invoice_number}
            </button>
          ))}
          <button
              className="btn btn-success ms-2 mb-2"
              onClick={() => setShowExportModal(true)}
          >
            <i className="ki-duotone ki-document fs-4 cursor-pointer">
              <span className="path1"></span>
              <span className="path2"></span>
            </i>{" "}
            {t("common.export")} PDF/XLSX
          </button>

          {opportunity?.current_opportunity_state?.state_id == 100 && (
              <button
                  className="btn btn-success ms-2 mb-2"
                  onClick={() => setShowExportSNModal(true)}
              >
                <i className="ki-duotone ki-document fs-4 cursor-pointer">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>{" "}
                {t("opportunities.exportSN")} CSV/XLSX
              </button>
          )}
          {/*
          <button
              className="btn btn-warning ms-2 mb-2"
              onClick={() => setShowClaimModal(true)}
          >
            <i className="ki-duotone ki-shield-cross fs-4 cursor-pointer">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
            </i>{" "}
            {t("claims.newClaim")}
          </button>
          */}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-lg-3 mb-5 mb-lg-0">
          <div className="card h-100">
            <div className="card-header">
              <h3 className="card-title">{t("opportunities.endCustomer")}</h3>
            </div>
            <div className="card-body">
              <h3 className="text-primary">
                {opportunity.end_customer?.name}
                &nbsp;
                {isWritable() && false && (
                  <i
                    className="ki-duotone ki-pencil fs-4 cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#opportunity_edit_end_customer_company_id"
                  >
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                )}
              </h3>
              <p>
                {opportunity.end_customer?.street}
                <br />
                {opportunity.end_customer?.city}
              </p>
              <p>
                <strong className="text-primary">{t("opportunities.companyId")}</strong>{" "}
                {opportunity.end_customer?.ic}
                <br />
                <strong className="text-primary">{t("opportunities.taxId")}</strong>{" "}
                {opportunity.end_customer?.dic}
              </p>
              {opportunity.end_customer && opportunity.end_customer.person && (
                <p>
                  <strong className="text-primary">{t("opportunities.contactPerson")}: </strong>
                  {opportunity.end_customer?.person.first_name +
                    " " +
                    opportunity.end_customer?.person.last_name}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 mb-5 mb-lg-0">
          <div className="card h-100">
            <div className="card-header">
              <h3 className="card-title">{t("opportunities.basicInfo")}</h3>
            </div>
            <div className="card-body">
              {/* 826851 */}
              {opportunity.access_rights_of_current_user !==
                "readWithoutPrice" && (
                <>
                  <div className="text-primary">{t("opportunities.expectedSale")}:</div>
                  <h4>
                    {number_format(
                      opportunity.purchase_total_price_local_currency,
                      2,
                      ",",
                      "."
                    )}
                    &nbsp;
                    {opportunity.local_currency}
                  </h4>
                  <div className="text-primary">{t("opportunities.currency")}</div>
                  <h4>
                    {opportunity.purchase_currency}
                    &nbsp;
                    {isWritable() && (
                      <i
                        className="ki-duotone ki-pencil fs-4 cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#opportunity_edit_invoice_currency"
                      >
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>
                    )}
                  </h4>
                  <hr />
                </>
              )}
              <div className="text-primary">{t("opportunities.dateCreated")}:</div>
              <h4>{new Date(opportunity.create_date).toLocaleDateString()}</h4>
              {opportunity.inquiry_date && opportunity.inquiry_date != "0000-00-00 00:00:00" && (
                <>
                  <div className="text-primary">{t("opportunities.dateSent")}:</div>
                  <h4>
                    {opportunity.inquiry_date && new Date(opportunity.inquiry_date).toLocaleDateString()} {opportunity.inquiry_date}
                  </h4>
                </>
              )}
              <div className="text-primary">{t("opportunities.dateInvoiced")}:</div>
              <h4>
                {new Date(opportunity.invoice_date).toLocaleDateString()}
                &nbsp;
                {isWritable() && (
                  <i
                    className="ki-duotone ki-pencil fs-4 cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#opportunity_edit_invoice_date"
                  >
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                )}
              </h4>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 mb-5 mb-lg-0">
          <div className="card h-100">
            <div className="card-header">
              <h3 className="card-title">{t("opportunities.dealState")}</h3>
            </div>
            <div className="card-body" style={{ paddingTop: "0px" }}>
              <Doughnut
                id="grafObchodu"
                data={{
                  labels: ["Filled", "Empty"],
                  datasets: [
                    {
                      data: [
                        opportunity.current_opportunity_state.state_id,
                        100 - opportunity.current_opportunity_state.state_id,
                      ],
                      backgroundColor: ["#D1B375", "#F2E8D6"],
                      borderWidth: 0,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  cutout: "50%",
                  rotation: 225,
                  circumference: 270,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                  },
                }}
              />
              <h3 className="text-center">
                <span>{opportunity.current_opportunity_state.state_name}</span>
              </h3>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 mb-5 mb-lg-0">
          <div className="card h-100">
            <div className="card-header">
              <h3 className="card-title">{t("opportunities.businessContact")}</h3>
            </div>
            <div className="card-body">

              {isWritable() && user?.current_branches_persons?.length > 1 && (
                  <div className="mb-10">
                    <label htmlFor="formPobocka" className="required form-label">
                      {t("common.company_branch")}
                    </label>

                    <select className="form-select form-select-solid form-select-sm"
                            defaultValue={opportunity.sales_person.company_branch_id}
                            required={true}
                            onChange={(e) => editOppotunityShort({company_branch_id: e.target.value})}
                    >
                      {user.current_branches_persons.map(branchPerson=>(
                          <option value={branchPerson.company_branch_id}>
                            {branchPerson.company_branch_name}
                          </option>
                      ))}
                    </select>
                  </div>
              )}

              {opportunity.exn_person && (
                <>
                  <p>
                    <strong>
                      {opportunity.exn_person.first_name}{" "}
                      {opportunity.exn_person.last_name}
                    </strong>{" "}
                    <div className="text-primary">
                      <small>za Exclusive Networks</small>
                    </div>
                  </p>
                  <div>
                    <a href={"mailto:" + opportunity.exn_person.email}>
                      {opportunity.exn_person.email}
                    </a>
                    <br />
                    <a href={"tel:" + opportunity.exn_person.phone}>
                      {opportunity.exn_person.phone}
                    </a>
                  </div>
                  <hr />
                </>
              )}
              {opportunity.sales_person && (
                <p>
                  <strong>
                    {opportunity.sales_person.first_name +
                      " " +
                      opportunity.sales_person.last_name}
                  </strong>{" "}
                  <div className="text-primary">
                    <small>za {opportunity.sales_person.company_name}</small>
                  </div>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      {opportunity.connected_opportunities &&
        opportunity.connected_opportunities.length > 0 && (
          <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold mb-5 mt-5">
            {opportunity.connected_opportunities?.map(
              (connectedOpportunity) => (
                <li className="nav-item">
                  <NavLink
                    to={"/prilezitost/" + connectedOpportunity}
                    className="nav-link"
                    aria-current="page"
                    href="#"
                  >
                    {t("opportunities.opportunityShort")}{connectedOpportunity}
                  </NavLink>
                </li>
              )
            )}
          </ul>
        )}
      <div className="d-md-none">
        <Accordion defaultActiveKey={0}>
          {opportunity.opportunity_variations?.map(
            (opportunity_variation, key) => (
              <Accordion.Item eventKey={key} key={key}>
                <Accordion.Header onClick={() => setActiveVariation(key)}>
                  {opportunity_variation.description}
                  {opportunity_variation.is_default && (
                    <span className="badge badge-primary ms-2">
                      {t("opportunities.mainVariant")}
                    </span>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  {opportunity.opportunity_variations[key]?.is_default ===
                    false &&
                    isWritable() && (
                      <button
                        className="btn btn-primary btn-sm mb-3 w-100"
                        onClick={() =>
                          setDefaultVariation(
                            opportunity.opportunity_variations[key]
                              ?.variation_id
                          )
                        }
                      >
                        {t("opportunities.markAsMain")}
                      </button>
                    )}
                  <div>
                    {opportunity.opportunity_variations[activeVariation]?.items
                      ?.length > 0 ? (
                      opportunity.opportunity_variations[
                        activeVariation
                      ]?.items.map((item) => (
                        <div className="card mb-3">
                          <div
                            className="card-header"
                            style={{ backgroundColor: "#efefef" }}
                          >
                            <h3 className="card-title">
                              {item.product.product_family +
                                ": " +
                                item.product.product_type +
                                " " +
                                item.product.name}
                            </h3>
                          </div>
                          <div className="card-body">
                            <div className="badge badge-info badge-outline mb-3">
                              {item.product.sku}
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <small style={{ fontWeight: "bold" }}>
                                  {t("opportunities.quantityPieces")}
                                </small>
                                <div>
                                  {" "}
                                  <input
                                    type="number"
                                    defaultValue={item.quantity}
                                    key={"quantityMobile" + item.item_id}
                                    className="form-control"
                                    onChange={(e) =>
                                      changeProduct(
                                        item.item_id,
                                        e.target.value
                                      )
                                    }
                                    disabled={!isWritable()}
                                  />
                                </div>
                              </div>
                              {opportunity.access_rights_of_current_user !==
                                "readWithoutPrice" && (
                                <div className="col-6">
                                  <small style={{ fontWeight: "bold" }}>
                                    {t("opportunities.discount")}
                                  </small>
                                  <div>{item.discount}%</div>
                                </div>
                              )}
                            </div>
                            {opportunity.access_rights_of_current_user !==
                              "readWithoutPrice" && (
                              <div className="row mt-5">
                                <div className="col-6">
                                  <small style={{ fontWeight: "bold" }}>
                                    {t("opportunities.price")}
                                  </small>
                                  <div>
                                    {number_format(item.eu_price, 2, ",", ".")}
                                    &nbsp;
                                    {item.currency}
                                  </div>
                                </div>
                                <div className="col-6">
                                  <small style={{ fontWeight: "bold" }}>
                                    {t("opportunities.totalPrice")}
                                  </small>
                                  <div>
                                    {number_format(
                                      item.eu_price *
                                        item.quantity *
                                        ((100 - item.discount) / 100),
                                      2,
                                      ",",
                                      "."
                                    )}
                                    &nbsp;
                                    {item.currency}
                                    {item.quantity > 1 && (
                                      <div>
                                        <small>
                                          ({item.quantity} ×{" "}
                                          {number_format(
                                            item.eu_price *
                                              ((100 - item.discount) / 100),
                                            2,
                                            ",",
                                            "."
                                          )}
                                          &nbsp;
                                          {item.currency})
                                        </small>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="row mt-5">
                              <div className="col-12">
                                {" "}
                                {item.sn && item.sn.length > 0 && (
                                  <div>
                                    <small>
                                      <strong>SN:</strong>{" "}
                                    </small>
                                    <div>
                                      {item.sn.map((sn, index) => (
                                        <span key={index}>
                                          {index > 0 ? ", " : ""}
                                          <a
                                            href="javascript:;"
                                            onClick={() => setShowSN(sn)}
                                          >
                                            {sn}
                                          </a>
                                        </span>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="card-footer">
                            {" "}
                            <button
                              onClick={() => deleteProduct(item.item_id)}
                              className="btn btn-sm btn-danger w-100"
                              disabled={!isWritable()}
                            >
                              {t("common.delete")}
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="alert alert-danger">
                        {t("opportunities.variantEmpty")}
                      </div>
                    )}
                  </div>
                  {isWritable() && (
                    <>
                      <button
                        className="btn btn-primary mt-5 w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#product-add"
                      >
                        <i className="ki-duotone ki-plus fs-4 cursor-pointer">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        {t("opportunities.addProduct")}
                      </button>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )
          )}
        </Accordion>
        {opportunity.opportunity_variations[activeVariation]?.is_default ===
          true &&
          opportunity.access_rights_of_current_user == "writeAndOrder" && (
            <div className="card mt-3">
              <div className="row card-body">
                <div className="col-12 pb-3">
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => setShowOrderModal(true)}
                  >
                    <i className="ki-duotone ki-purchase fs-4 cursor-pointer">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>{" "}
                    {t("opportunities.order")}
                  </button>
                </div>
                {!opportunity.inquiry_date && (
                  <div className="col-12 pb-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={() => editOppotunityShort({ sendInquiry: true })}
                    >
                      <i className="ki-duotone ki-purchase fs-4 cursor-pointer">
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>{" "}
                      {t("opportunities.sendInquiry")}
                    </button>
                  </div>
                )}
                <div className="col-12">
                  <button
                    className="btn btn-danger w-100"
                    onClick={() => cancelOpportunity()}
                  >
                    <i className="ki-duotone ki-trash fs-4 cursor-pointer">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>{" "}
                    {t("opportunities.cancelDeal")}
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
      <div className="d-none d-md-block mt-5">
        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
          {opportunity.opportunity_variations?.map(
            (opportunity_variation, key) => (
              <li className="nav-item" key={key}>
                <span
                  className={
                    "cursor-pointer nav-link " +
                    (key == activeVariation && "active")
                  }
                  aria-current="page"
                  onClick={() => setActiveVariation(key)}
                >
                  {opportunity_variation.description}{" "}
                  {opportunity_variation.is_default && (
                    <span className="badge badge-primary ms-2">
                      {t("opportunities.mainVariant")}
                    </span>
                  )}
                </span>
              </li>
            )
          )}
          {isWritable() && (
            <li className="nav-item">
              <span
                className="cursor-pointer nav-link"
                aria-current="page"
                data-bs-toggle="modal"
                data-bs-target="#variant-new"
              >
                <i className="ki-duotone ki-plus fs-4 cursor-pointer">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </span>
            </li>
          )}
        </ul>

        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            {opportunity.opportunity_variations[activeVariation]?.is_default ===
              false &&
              isWritable() && (
                <button
                  className="btn btn-primary btn-sm mt-3"
                  onClick={() =>
                    setDefaultVariation(
                      opportunity.opportunity_variations[activeVariation]
                        ?.variation_id
                    )
                  }
                >
                  {t("opportunities.markAsMain")}
                </button>
              )}
            <div className="card mt-6">
              <div className="card-body pt-0">
                {opportunity.opportunity_variations[activeVariation]?.items
                  ?.length > 0 ? (
                  <div
                    id="kt_customers_table_wrapper"
                    className="dt-container dt-bootstrap5 dt-empty-footer"
                  >
                    <div id="" className="table-responsive">
                      <table
                        className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                        id="kt_customers_table"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th>{t("opportunities.product")}</th>
                            <th>{t("opportunities.quantity")}</th>
                            {opportunity.access_rights_of_current_user !==
                              "readWithoutPrice" && (
                              <>
                                <th>{t("opportunities.price")}</th>
                                <th>{t("opportunities.discount")} %</th>
                                <th>{t("opportunities.totalAfterDiscount")}</th>
                              </>
                            )}
                            <th>{t("opportunities.actions")}</th>
                          </tr>

                          {/*<th className="min-w-150px dt-orderable-asc dt-orderable-desc text-end"
                                            data-dt-column="2" rowSpan="1" colSpan="1"
                                            aria-label="Email: Activate to sort" tabIndex="0"><span
                                            className="dt-column-title" role="button">Akce</span><span
                                            className="dt-column-order"></span></th>*/}
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                          {opportunity.opportunity_variations &&
                            opportunity.opportunity_variations[
                              activeVariation
                            ]?.items.map((item, key) => (
                              <tr key={key}>
                                <td>
                                  <h6>
                                    {item.product.product_family}:{" "}
                                    {item.product.product_type}
                                  </h6>
                                  <strong>{item.product.name}</strong>
                                  <div>
                                    <span className="badge badge-info badge-outline">
                                      {item.product.sku}
                                    </span>
                                    {item.inWarehouse && (
                                        <span className="ms-3 badge badge-success badge-outline">
                                      Ze skladu
                                    </span>
                                    )}
                                    {item.product.vendor_id !== 40 && (
                                      <span
                                        className={
                                          "ms-3 badge badge-secondary badge-vendor-" +
                                          item.product.vendor_id
                                        }
                                      >
                                        {item.product.vendor_name}
                                      </span>
                                    )}
                                  </div>
                                  {item.sn && item.sn.length > 0 && (
                                    <div>
                                      <small>
                                        <strong>SN:</strong>{" "}
                                        {item.sn.map((sn, index) => (
                                          <span key={index}>
                                            {index > 0 ? ", " : ""}
                                            <a
                                              href="javascript:;"
                                              onClick={() => setShowSN(sn)}
                                            >
                                              {sn}
                                            </a>
                                          </span>
                                        ))}
                                      </small>
                                    </div>
                                  )}
                                </td>
                                <td className="w-100px">
                                  <input
                                    type="number"
                                    defaultValue={item.quantity}
                                    key={"item" + item.item_id}
                                    className="form-control"
                                    onChange={(e) =>
                                      changeProduct(
                                        item.item_id,
                                        e.target.value
                                      )
                                    }
                                    disabled={!isWritable()}
                                  />
                                </td>
                                {opportunity.access_rights_of_current_user !==
                                  "readWithoutPrice" && (
                                  <>
                                    <td>
                                      {number_format(
                                        item.eu_price*item.quantity,
                                        2,
                                        ",",
                                        "."
                                      )}
                                      &nbsp;
                                      {item.currency}
                                        {item.quantity > 1 && (
                                            <div>
                                                <small className="text-gray-600">
                                                    {number_format(
                                                        item.eu_price,
                                                        2,
                                                        ",",
                                                        "."
                                                    )}
                                                    &nbsp;
                                                    {item.currency} / {t("opportunities.piece")}
                                                </small>
                                            </div>
                                        )}
                                    </td>
                                    <td>{item.discount}%</td>
                                    <td>
                                      {number_format(
                                        item.eu_price *
                                          item.quantity *
                                          ((100 - item.discount) / 100),
                                        2,
                                        ",",
                                        "."
                                      )}
                                      &nbsp;
                                      {item.currency}
                                      {item.quantity > 1 && (
                                        <div>
                                          <small className="text-gray-600">
                                            {number_format(
                                              item.eu_price *
                                                ((100 - item.discount) / 100),
                                              2,
                                              ",",
                                              "."
                                            )}
                                            &nbsp;
                                            {item.currency} / {t("opportunities.piece")}
                                          </small>
                                        </div>
                                      )}
                                    </td>
                                  </>
                                )}
                                <td>
                                  <button
                                    onClick={() => deleteProduct(item.item_id)}
                                    className="btn btn-sm btn-danger"
                                    disabled={!isWritable()}
                                  >
                                    {t("common.delete")}
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <p className="mt-5">{t("opportunities.noProducts")}</p>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div>
                {isWritable() && (
                  <div className="d-flex gap-4 mt-5">
                    <button
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#product-add"
                    >
                      <i className="ki-duotone ki-plus fs-4 cursor-pointer">
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>
                      {t("opportunities.addProduct")}
                    </button>

                    <Dropdown className="d-none">
                      <Dropdown.Toggle variant="default">...</Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item>{t("opportunities.fromSelfService")}</Dropdown.Item>
                        <Dropdown.Item>{t("opportunities.fromSale")}</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
              <div>
                <div className="d-flex mt-5">
                  {opportunity.opportunity_variations[activeVariation]
                    ?.is_default === true &&
                    opportunity.access_rights_of_current_user ==
                      "writeAndOrder" && (
                      <>
                        <button
                          className="btn btn-primary me-5"
                          onClick={() => setShowOrderModal(true)}
                        >
                          <i className="ki-duotone ki-purchase fs-4 cursor-pointer">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>{" "}
                          {t("opportunities.order")}
                        </button>
                        {!opportunity.inquiry_date && (
                          <button
                            className="btn btn-primary me-5"
                            onClick={() =>
                              editOppotunityShort({ sendInquiry: true })
                            }
                          >
                            <i className="ki-duotone ki-purchase fs-4 cursor-pointer">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>{" "}
                            {t("opportunities.sendInquiry")}
                          </button>
                        )}
                        <button
                          className="btn btn-danger"
                          onClick={() => cancelOpportunity()}
                        >
                          <i className="ki-duotone ki-trash fs-4 cursor-pointer">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>{" "}
                          {t("opportunities.cancelDeal")}
                        </button>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            ...
          </div>
          <div
            className="tab-pane fade"
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
          >
            ...
          </div>
        </div>
      </div>
      <div className="row mt-10">
        <div className="col-12 col-md-7 mb-5">
          <h3>{t("opportunities.notes")}</h3>

          <Comments
            objectId={opportunity.opportunity_id}
            objectType={"opportunity"}
            callback={() => setReload(reload + 1)}
            comments={opportunity.comments}
          />
        </div>
        <div className="col-12 col-md-5">
          <h3>{t("opportunities.attachments")}</h3>
          {opportunity.attachments?.length === 0 ? (
            <p>{t("opportunities.noAttachments")}</p>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center flex-column p-8">
                <table className="w-100">
                  <tbody>
                    {opportunity.attachments?.map(
                      (attachment, attachment_key) => (
                        <tr key={attachment_key}>
                          <td
                            onClick={() =>
                              PartnerApi.download(
                                "/attachment/" +
                                  attachment.file_id +
                                  "/" +
                                  attachment.file_name,
                                attachment.file_name,
                                token
                              )
                            }
                            className="cursor-pointer w-30px pe-5"
                          >
                            {attachment.file_type == "application/pdf" && (
                              <img
                                src="/assets/media/svg/files/pdf.svg"
                                alt=""
                              />
                            )}
                            {attachment.file_type == "application/zip" && (
                              <img
                                src="/assets/media/svg/files/zip.svg"
                                alt=""
                              />
                            )}
                            {attachment.file_type == "image/jpeg" && (
                              <img
                                src="/assets/media/svg/files/jpg.svg"
                                alt=""
                              />
                            )}
                          </td>
                          <td
                            onClick={() =>
                              PartnerApi.download(
                                "/attachment/" +
                                  attachment.file_id +
                                  "/" +
                                  attachment.file_name,
                                attachment.file_name,
                                token
                              )
                            }
                            className="cursor-pointer text-left align-middle"
                          >
                            <div className="fs-5 fw-bold">
                              {attachment.file_name}
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {!isInternalAdmin && (
              <>
                <h3 className="mt-10">{t("shipping.title")}</h3>
                {opportunity.shipping ? (
                    <div className="card">
                      <div className="card-body d-flex justify-content-center flex-column p-8">
                        <ShippingTableOpp shipping={opportunity.shipping} />
                      </div>
                    </div>
                ) : (
                    <p>{t("common.noData")}</p>
                )}
              </>
          )}
        </div>
      </div>


      {opportunity && (
          <ShippingPackagesTableOpp
              opportunity={opportunity}
              isInternalAdmin={isInternalAdmin}
          />
      )}

      {opportunity && (
          <ClaimNewModal
              show={showClaimModal}
              handleClose={() => setShowClaimModal(false)}
              opportunity={opportunity}
          />
      )}

      {opportunity?.claims && opportunity.claims.length > 0 && (
        <div className="mt-10">
          <h3>{t("claims.title")}</h3>
          <div className="card">
            <div className="card-body">
              <table className="table align-middle table-row-dashed fs-6 gy-5">
                <thead>
                  <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                    <th>{t("claims.claimId")}</th>
                    <th>{t("claims.state")}</th>
                    <th>{t("claims.createdDate")}</th>
                    <th>{t("claims.description")}</th>
                    <th>{t("common.actions")}</th>
                  </tr>
                </thead>
                <tbody className="fw-semibold text-gray-600">
                  {opportunity.claims.map((claim) => (
                    <tr key={claim.claim_id}>
                      <td>{claim.claim_id}</td>
                      <td>{claim.state_name}</td>
                      <td>
                        {claim.created_date
                          ? new Date(claim.created_date).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{claim.defect_description_short}</td>
                      <td>
                        <NavLink
                          className="btn btn-primary btn-sm"
                          to={"/reklamace/" + claim.claim_id}
                        >
                          {t("common.detail")}
                        </NavLink>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {opportunity && (
          <OpportunityExportModal
              opportunity={opportunity}
              show={showExportModal}
              handleClose={()=>setShowExportModal(false)}
          />
      )}

      {opportunity && (
          <OpportunityExportSNModal
              opportunity={opportunity}
              show={showExportSNModal}
              handleClose={()=>setShowExportSNModal(false)}
          />
      )}
    </>
  );
}

export default Opportunity;
